export default "__VITE_ASSET__BzDXfVr5__"